module.exports = __webpack_public_path__ + "img/森宇文化.7f5fe207.png";